import UserManagement from "@/views/console/UserManagement";
import C from "@/utils/constants";

export default [
  {
    path: "user-management",
    component: UserManagement,
    meta: {
      roles: [
        C.ROLE.ADMIN,
        C.ROLE.MANAGER,
        C.ROLE.QA_TEAM,
        C.ROLE.CSR_SUPERVISOR,
      ],
    },
    children: [
      {
        path: "",
        name: "user-management",
        component: () => import("../components/console/users/UsersList"),
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.QA_TEAM,
            C.ROLE.CSR_SUPERVISOR,
          ],
        },
      },
      {
        path: "create",
        name: "user-create",
        components: {
          default: () => import("../components/console/users/UsersList"),
          edit: () => import("../components/console/users/UserEdit"),
        },
        props: {
          edit: { mode: "create" },
        },
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.QA_TEAM,
            C.ROLE.CSR_SUPERVISOR,
          ],
        },
      },
      { path: "edit", redirect: "/console/user-management" },
      {
        path: "edit/:id",
        name: "user-edit",
        components: {
          default: () => import("../components/console/users/UsersList"),
          edit: () => import("../components/console/users/UserEdit"),
        },
        props: {
          edit: (route) => {
            return {
              mode: "edit",
              userId: route.params.id,
            };
          },
        },
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.QA_TEAM,
            C.ROLE.CSR_SUPERVISOR,
          ],
        },
      },
    ],
  },
];
